import productBuyBox from '../components/productBuyBox'
import productGallery from '../components/productGallery'

const product = {
  init() {
    if(document.getElementById('productTemplate')) {
      productBuyBox.init()
      productGallery.init()
    }
  }
}

export default product